import { render, staticRenderFns } from "./Listas.vue?vue&type=template&id=1bea9e63&scoped=true&"
import script from "./Listas.vue?vue&type=script&lang=js&"
export * from "./Listas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bea9e63",
  null
  
)

export default component.exports